(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tap-volume-offer"] && !Shopify.designMode) return;
  try {
    /* Suppress proactive product suggestions while retaining the normal chat launcher. */
function tapHideProactiveSuggestions(){
 const prompt='You might like this product!';
 document.querySelectorAll('p,span,h2,h3,div').forEach(node=>{
  if(node.textContent.trim()!==prompt)return;
  let panel=node.parentElement;
  for(let depth=0;panel&&depth<7;depth++,panel=panel.parentElement){
   if(panel===document.body||panel===document.documentElement)break;
   const text=panel.textContent;
   if(text.includes('View similar')&&text.includes('Ask about it')){
    panel.classList.add('tap-chatty-suggestion-hidden');break;
   }
  }
 });
}
function tapWatchProactiveSuggestions(){
 tapHideProactiveSuggestions();
 let queued=false;
 new MutationObserver(records=>{
  if(queued||!records.some(record=>[...record.addedNodes].some(node=>/You might like this product!|View similar|Ask about it/.test(node.textContent||''))))return;
  queued=true;requestAnimationFrame(()=>{queued=false;tapHideProactiveSuggestions()});
 }).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',tapWatchProactiveSuggestions,{once:true});else tapWatchProactiveSuggestions();

if(!customElements.get('tap-pdp-quantity'))customElements.define('tap-pdp-quantity',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const tagline=this.querySelector('.tap-quantity-tagline');if(tagline&&!matchMedia('(prefers-reduced-motion: reduce)').matches){tagline.classList.add('tap-words-ready');const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)tagline.classList.add('tap-words-visible');else tagline.classList.remove('tap-words-visible')})},{threshold:.75});observer.observe(tagline)}this.scope=this.closest('.product-details')||this.closest('product-component');this.buttons=[...this.querySelectorAll('[data-quantity]')];this.buttons.forEach(button=>button.addEventListener('click',()=>{const input=this.scope?.querySelector('input[name="quantity"]');if(!input)return;input.value=button.dataset.quantity;input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));input.dispatchEvent(new FocusEvent('blur',{bubbles:true}));this.mark(input.value)}));this.scope?.addEventListener('click',()=>requestAnimationFrame(()=>this.mark(this.scope.querySelector('input[name="quantity"]')?.value)));this.scope?.addEventListener('change',event=>{if(event.target.matches('input[name="quantity"]'))this.mark(event.target.value)})}
mark(value){this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.quantity===String(value))))}
});
  } catch(e) { console.error(e); }
})();

})();
